import axiosClient from '@/services/axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

const fetchBreadcrumb = createAsyncThunk(
  'ratings/fetchBreadcrumb',
  async ({ productSlug, queryParams = {} }, { rejectWithValue }) => {
    if (productSlug === undefined) {
      return rejectWithValue('Product slug is undefined');
    }

    const queryString = new URLSearchParams(queryParams).toString();

    let url = `/api/products/${productSlug}/breadcrumb`;
    url += queryString ? `?${queryString}` : '';

    try {
      const response = await axiosClient.get(url);
      return response.data?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export default fetchBreadcrumb;
